import React from "react";
import { Col, Row } from "react-bootstrap";
import LoadReports from "../../../components/generate-reports/HomeReports"

const Reports = () => {
  return (
    <Row>
      <Col col={12} className="col-12 mb-3">
        <LoadReports />
      </Col>
    </Row>
  );
};

export default Reports;
